import React from 'react'
import styled from 'styled-components'
import { pxToRem } from '../../utils'

const Wrapper = styled.div`
  display: inline-block;
  position: absolute;
  left: 0;
  right: 0;
  padding-left: ${pxToRem('30px')};
  box-sizing: border-box;
  div {
    height: 5.6em;
    position: relative;
    border-bottom: 1px solid #d8d8d8;
    opacity: .2;
    &:nth-child(1) {
      animation: loader-anim  0 .6s alternate infinite linear;
    }
    &:nth-child(2) {
      animation: loader-anim 1.6s alternate infinite linear;
    }
    &:nth-child(3) {
      animation: loader-anim 1.6s alternate infinite linear;
    }
    &::after {
        content: '';
        display: inline-block;
        background: #e8e8e8;
        width: calc(100% - ${pxToRem('30px')});
        height: 10px;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
    }
    &::before {
        content: '';
        display: inline-block;
        background: #e8e8e8;
        width: calc(90% - ${pxToRem('30px')});
        height: 10px;
        position: absolute;
        top: 50%;
        bottom: 0;
        margin: auto;
    }
    /* margin: 2.5em 0 1em; */
  }

  @keyframes loader-anim {
    from {
      opacity: .2;
    }
    to {
      opacity: 1;
    }
  }
`

const PlaceholderMenu = () => (
  <Wrapper>
    <div>
    </div>
    <div>
    </div>
    <div>
    </div>
    <div>
    </div>
  </Wrapper>
)

export default PlaceholderMenu



// WEBPACK FOOTER //
// ./src/components/loaders/PlaceholderMenu.js